/** The `notes` area: a note on a statement (src/domain/statement-notes.ts). */
export const notes = {
  'notes.refusal.malformedCitation': 'Malformed statement citation.',
  'notes.refusal.notItsItem':
    "A note belongs to the statement at its own item. For another item's effect on your promise, set a state citing the statement, or say your item is not affected.",
  'notes.refusal.empty': 'Note is empty.',
  'notes.refusal.tooLong': 'A statement note is limited to {max} characters.',
} as const;
